export const menu = [
	{
		text: "Home",
		link: "/",
	},
	{
		text: "KYC",
		link: "/kyc",
	},
	{
		text: "Apply",
		link: "/apply",
	},
	{
		text: "Staking",
		// link: "https://app.yieldly.finance/",
		link: "/staking",
		// target: "_blank",
	},
	{
		text: "Dashboard",
		link: "/dashboard",
	},
	{
		text: "Stats",
		link: "/stats",
	},
	{
		text: "yNFT",
		link: "https://ynft.club",
		target: "_blank",
	},
	{
		text: "yAMM",
		link: "/yamm",
		// tbc: "Upcoming!",
		tbc: "TBD",
		disabled: true,
	},
	{
		text: "Legacy",
		link: "https://app.yieldly.finance/pools",
		target: "_blank",
	},
	{
		text: "About",
		link: "/about",
	},
];
